module.exports = __webpack_public_path__ + "static/media/he-item-builder-thumbnail.6becef1e.PNG";